import type { ThermalState } from './types';

/** Block when battery is strictly below this fraction (20%). */
export const MIN_BATTERY_LEVEL = 0.2;

/** Minimum acceptable delivered FPS after warmup. */
export const MIN_DELIVERED_FPS = 10;

/** Skip FPS enforcement for the first N seconds of a scan (camera warmup). */
export const FPS_WARMUP_MS = 3000;

/**
 * Thermal states that hard-block the scan.
 * Web cannot read OS thermal state; kept for parity with the native evaluator.
 */
export const BLOCKING_THERMAL_STATES: ReadonlySet<ThermalState> = new Set([
  'critical',
]);
